import { Link } from 'react-router-dom';
import { LandingLayout } from './LandingLayout';

export function ThanksPage() {
  return (
    <LandingLayout>
      <div style={{ textAlign: 'center', paddingTop: 80 }}>
        <div className="landing-brand-logo">
          <img
            src="/help-from-sky-logo.png"
            alt="Help from Sky"
            className="landing-logo-img"
          />
        </div>

        <h1>You're on the list!</h1>
        <p className="landing-hero-sub">
          Thanks for signing up. We'll be in touch soon with your beta invite.
        </p>

        <div style={{ marginTop: 32 }}>
          <Link to="/" className="landing-button">
            Back to home
          </Link>
        </div>
      </div>
    </LandingLayout>
  );
}
